import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";

import MetaTags from 'react-meta-tags';
import Box from "@material-ui/core/Box";
import GeneralStyles from '../../styles/GeneralStyles';
import axios from 'axios';
// import { useCookies } from 'react-cookie';
// import cookieName from '../../helpers/cookiesDeclaration';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment';

const useGeneralStyles = GeneralStyles;

function NewsContent(props) {
    const classesG = useGeneralStyles();
    const [newsContent, setNewsContent] = useState(null);
    // const [cookies, setCookie] = useCookies([cookieName]);
    const [loading, setLoading] = useState(false);
    const matchMobile = useMediaQuery('(max-width:600px)');

    const { url } = useParams();

    useEffect(() => {
        setLoading(true);
        if (url !== '' && url !== undefined && url !== null) {
            axios
                .get(
                    `${process.env.REACT_APP_GATEWAY_END_POINT}/news-content/${url}`)
                .then((response) => {
                    setNewsContent(response.data);
                    setLoading(false);
                })
                .catch((error) => {
                    setLoading(true);
                });
        } else {
            setLoading(false);
            const { history, location } = props;
            const { from } = location.state || {
                from: {
                    pathname: '/news',
                },
            };
            history.push(from);
        }
    }, [url, props]);

    useEffect(() => {
        if (url !== '' && url !== undefined && url !== null && loading !== true) {
            var video2 = document.getElementById("video2");

            if (video2 !== null) {

                document.addEventListener("fullscreenchange", function () {
                    if (document.fullscreenElement === null && video2 !== null && video2 !== undefined) {
                        video2.style.display = "none";
                        video2.pause();
                    }
                }, false);

                document.addEventListener("mozfullscreenchange", function () {
                    if (document.mozFullScreen === false && video2 !== null && video2 !== undefined) {
                        video2.style.display = "none";
                        video2.pause();
                    }
                }, false);

                document.addEventListener("webkitfullscreenchange", function () {
                    if (document.webkitIsFullScreen === false && video2 !== null && video2 !== undefined) {
                        video2.style.display = "none";
                        video2.pause();
                    }

                }, false);

                document.addEventListener("webkitendfullscreense ", function () {
                    if (video2 !== null && video2 !== undefined) {
                        video2.style.display = "none";
                        video2.pause();
                    }
                }, false);

                video2.addEventListener('webkitendfullscreen', function () {
                    if (video2 !== null && video2 !== undefined) {
                        video2.style.display = "none";
                        video2.pause();
                    }
                }, false);
            }
        }

    }, [url, newsContent, loading])

    const openFullscreen = () => {
        var video = document.getElementById("video2");
        video.style.display = "block";

        if (video.requestFullscreen) {
            video.pause();
            video.currentTime = 0;
            video.play();
            video.requestFullscreen();
        } else if (video.webkitRequestFullscreen) { /* Safari */
            video.pause();
            video.currentTime = 0;
            video.play();
            video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) { /* IE11 */
            video.pause();
            video.currentTime = 0;
            video.play();
            video.msRequestFullscreen();
        } else if (video.webkitEnterFullscreen) { /* Mobile */
            video.pause();
            video.currentTime = 0;
            video.play();
            video.webkitEnterFullscreen();
        }
    }

    const replace = (param) => {
        var value = '';

        if (param !== '' && param !== null && param !== undefined) {
            value = param.replace(`${process.env.REACT_APP_GATEWAY_PATH_REPLACE}`, `${process.env.REACT_APP_GATEWAY_PATH_S3}`);
        }

        return value;
    }

    return (
        <React.Fragment>
            {loading && (
                <div className={classesG.divProgress}>
                    <CircularProgress size={68} className={classesG.progress} />
                </div>
            )}
            {!loading && (
                <React.Fragment>
                    {newsContent === null || newsContent === undefined ? '' : (
                        <React.Fragment>
                            <MetaTags>
                                <title>{newsContent.Page_Title}</title>
                                <meta name="description" content={newsContent.Page_Description} />
                            </MetaTags>

                            <div className={classesG.container}>

                                {newsContent.Priority_image === true ? '' : (
                                    <video src={matchMobile && newsContent.Mobile_video !== null ? replace(newsContent.Mobile_video.url) : replace(newsContent.Desktop_video.url)}
                                        playsInline id='video2' className={classesG.videoBackground_section} style={{ display: 'none' }}>
                                    </video>
                                )}

                                <section className={classesG.section}>
                                    <div className={classesG.workSecondSectionContent}>
                                        <div className={classesG.workSectionBox}>
                                            <div className={classesG.newsPagesFirstSectionText}>
                                                <h2>{newsContent.Title}</h2>
                                                <span>{moment(newsContent.Date).format("MMMM Do, YYYY")}</span>
                                                {newsContent.Priority_image === true ?
                                                    (
                                                        <img src={replace(newsContent.Image.url)} alt={newsContent.Title} />
                                                    ) : (
                                                        <div className={classesG.divVideo}>
                                                            <video src={replace(newsContent.Background_video.url)}
                                                                playsInline autoPlay={'autoplay'} loop={true} muted id='video1'>
                                                            </video>
                                                            <PlayCircleOutlineIcon id={'playButton'} onClick={openFullscreen} />
                                                        </div>
                                                    )}

                                                <br />
                                                <div dangerouslySetInnerHTML={{ __html: newsContent.Text }} />
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <Box mt={7}></Box>
                            </div>
                        </React.Fragment>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    );
}

export default (NewsContent);